<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on">
        <v-btn
            fab
            v-bind="attrs"
            v-on="on"
            :disabled="isDisabled"
            @click="Clicked"
        >
          <v-icon dark> {{ buttonIcon }} </v-icon>
        </v-btn>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  props: {
    isDisabled: Boolean,
    buttonIcon: String,
    tooltip: String
  },
  methods: {
    Clicked: function (){
      this.$emit("click");
    },
  },
})
</script>
